import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, action) => {
  return {
    'Click Name': `${action.payload.tabType} Product Card`,
    'Event Name': eventName,
    'Page Name': 'Catalogue Page'
  }
}

const clickOnProductCardTabCard = (action$, _state$) => action$.pipe(
  disableMixPanelTracking(action$),
  ofType(Actions.product.CLICK_ON_PRODUCT_CARD_TAB),
  tap(action => {
    const eventName = 'Click'

    track(eventName, mapStateToMPEvent(eventName, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickOnProductCardTabCard
